export default __webpack_public_path__ + "static/media/SplitType.55d8d276.png";